import React from 'react'
import { browserHistory } from 'react-router'
import FlatButton from 'material-ui/FlatButton'

const ValueLink = ({ value, path }) => (
  <FlatButton
    onClick={() => browserHistory.push(path)}
    label={value.toLocaleString()}
    secondary={value > 0}
    disabled={value === 0}
  />
)

// @ts-ignore
ValueLink.propTypes = {
  value: React.PropTypes.number.isRequired,
  path: React.PropTypes.string.isRequired
}

// @ts-ignore
ValueLink.defaultProps = {
  value: 0
}

export default ValueLink
